<template>
  <v-container>
    <v-row>
      <v-col>
        <material-table
            ref="device_list"
            title="终端列表"
            :url="device.table.api"
            :columns="device.table.headers"
            :data="device.table.list"
            :filter="device.table.filter"
            :searchValue="device.table.searchValue"
        >
          <template slot="title">
            <v-btn color="primary" @click="searchTable('device_list')">搜索</v-btn>
<!--            <v-btn color="primary" class="ml-5" @click="showDialog('device_add')">添加Ap组</v-btn>-->
            <v-btn color="primary ml-3"
                   dark
                   :loading="exportLoading"
                   @click="exportExcel">
                                        <span>
                                            {{$vuetify.lang.t('$vuetify.common.export')}}
                                        </span>
            </v-btn>
          </template>
          <!-- title -->
          <template slot="body">
            <v-card-subtitle>
              <v-row>
                <v-col cols="12" xs="12" sm="4" md="2" class="pt-0 pb-0">
                  <v-text-field
                      v-model="device.table.filter.mac"
                      placeholder="请输入mac地址"
                      label="mac"
                      append-outer-icon="search"
                      @click:append-outer="searchTable('device_list')"
                  ></v-text-field>
                </v-col>
                <!-- Apmac -->
<!--                <v-col cols="12" xs="12" sm="4" md="3" class="pt-0 pb-0">-->
<!--                  <v-autocomplete-->
<!--                      v-model="device.table.filter.group_id"-->
<!--                      @change="handleSearchGroupChange"-->
<!--                      :items="device.group_list"-->
<!--                      label="集团"-->
<!--                      placeholder="请选择所属集团"-->
<!--                      item-text="name"-->
<!--                      item-value="id"-->
<!--                      clearable-->
<!--                  ></v-autocomplete>-->
<!--                </v-col>-->
<!--                &lt;!&ndash; 集团 &ndash;&gt;-->
<!--                <v-col cols="12" xs="12" sm="4" md="3" class="pt-0 pb-0">-->
<!--                  <v-autocomplete-->
<!--                      v-model="device.table.filter.shop_id"-->
<!--                      :items="device.table.shop_list"-->
<!--                      label="场所"-->
<!--                      placeholder="请选择所属场所"-->
<!--                      item-text="name"-->
<!--                      item-value="id"-->
<!--                      clearable-->
<!--                  ></v-autocomplete>-->
<!--                </v-col>-->
                <!-- 场所 -->
              </v-row>
            </v-card-subtitle>
            <!-- 选择框 -->
          </template>
          <!-- search -->
          <template slot="action" slot-scope="data">
            <a class="span" v-if="data.value.item.status === '0'"  @click="showApGroupEdit(data.value.item)"><v-icon small>mdi-pencil</v-icon> 添加</a>
            <el-tag v-else type="success">已添加</el-tag>
<!--            <a class="span" @click="showApGroupDel(data.value.item)"><v-icon small>mdi-trash-can-outline</v-icon> 删除</a>-->
          </template>
          <!-- action -->
        </material-table>
        <!-- Ap组列表 -->
        <material-dialog ref="device_add" formTitle="添加AP组" @handleSave="doApgroupAdd">
          <template slot="content">
            <v-form ref="device_add_form" lazy-validation>
              <v-text-field v-model="device.add_dialog.data.device_name" label="组名"></v-text-field>
              <v-autocomplete
                  v-model="device.add_dialog.data.group_id"
                  @change="handleAddGroupChange"
                  :items="device.group_list"
                  label="集团"
                  placeholder="请选择所属集团"
                  item-text="name"
                  item-value="id"
                  clearable
              ></v-autocomplete>
              <v-autocomplete
                  v-model="device.add_dialog.data.shop_id"
                  :items="device.add_dialog.shop_list"
                  label="场所"
                  placeholder="请选择所属场所"
                  item-text="name"
                  item-value="id"
                  clearable
              ></v-autocomplete>
            </v-form>
          </template>
          <template slot="action">
            <v-btn color="blue darken-1" text @click="ReFresh('device_add_form')">重置</v-btn>
          </template>
        </material-dialog>
        <!-- Ap组添加框 -->
        <material-dialog ref="device_edit" formTitle="将此设备添加至MAC认证" @handleSave="doDeviceEdit">
          <template slot="content">
            <v-form ref="device_edit_form" lazy-validation>
              <v-select v-model="device.edit_dialog.data.set_id" @change="handleEditClassChange" :items="device.set" item-value="id" placeholder="请选择所属认证库" item-text="name"></v-select>
              <v-select v-model="device.edit_dialog.data.class_id" :items="device.class" item-value="id" placeholder="请选择所属认证组" item-text="name"></v-select>
            </v-form>
          </template>
        </material-dialog>
        <!-- Ap组修改框 -->
        <material-dialog ref="device_del" formTitle="删除AP组" @handleSave="doApGroupDel">
          <template slot="content">
            确认是否删除？<span style="color:red;">Ap组下所属Ap将被删除</span>
          </template>
        </material-dialog>
        <!-- Ap组删除框 -->
      </v-col>
    </v-row>

    <!-- AP列表 -->
  </v-container>
</template>
<script>
import axios from 'axios'
import api from '@/api.js'
import { Notification } from 'element-ui'
export default {
  data() {
    return {
      exportLoading: false,
      device: {
        set:{},
        class:{},
        table: {
          api:api.device.deviceList,
          searchValue:0,
          headers: [
            { text: 'mac', value: 'mac' },
            { text: 'ip', value: 'ip' },
            { text: '设备型号', value: 'type' },
            { text: 'AP组名', value: 'name' },
            { text: '备注', value: 'remark' },
            { text: '操作', value: 'action'}
          ],
          list: [],
          filter: {
            device_name: "",
            group_id: null,
            shop_id: null,
            mac: '',
          },
          shop_list:[],
          class: [],
          set: [],
        },
        group_list:[],
        add_dialog: {
          shop_list:[],
          data:{
            device_name: "",
            group_id: null,
            shop_id: null,
            set_id:'',
            class_id:''
          }
        },
        edit_dialog: {
          shop_list:[],
          data:{
            mac: "",
            ip: "",
            set_id:'',
            class_id:''
          }
        },
        del_dialog: {
          data: {
            device_id: null
          }
        }
      },
      ap: {
        table: {
          button:{
            download_ap_template_loading: false
          },
          api:api.device.apList,
          searchValue:0,
          headers: [
            { text: 'Mac地址', value: 'mac' },
            { text: 'Ap组名', value: 'device_name' },
            { text: '在线用户', value: 'count' },
            { text: '备注', value: 'remark' },
            { text: '状态', value: 'online_status' },
            { text: '操作', value: 'action'}
          ],
          list: [],
          filter: {
            apmac: "",
            device_id: null,
          }
        },
        add_dialog: {
          data:{
            apmac: "",
            remark: "",
            device_id: null,
          }
        },
        edit_dialog: {
          data:{
            ap_id: null,
            apmac: "",
            remark: "",
            device_id: null,
            set_id: '',
            class_id:''
          }
        },
        del_dialog: {
          data: {
            ap_id: null
          }
        },
        import_dialog: {
          data: {
            file: null
          }
        },
        device_list:[]
      },
      userParams:{
        set_id: '',
        username: '',
      }
    }
  },
  mounted() {
  },
  created() {
    this.getClassList()
  },
  methods : {
    /**
     * 通用函数
     */
    showDialog(ref_name){
      this.$refs[ref_name].showDialog()
    },
    closeDialog(ref_name){
      this.$refs[ref_name].closeDialog()
    },
    reflushTable(ref_name){
      if(ref_name == "device_list" || ref_name == "device_edit")
      {
        this.searchTable(ref_name)
      }
      // this.$refs[ref_name].getDataFromApi()
    },
    searchTable(ref_name){
      this.$refs[ref_name].searchTable()
    },
    ReFresh(ref_name){
      this.$refs[ref_name].reset()
    },
    /**
     * 显示Dialog
     */
    showApGroupEdit(item){
      this.device.edit_dialog.data = {
        mac: item.mac,
        ip: item.ip,
      }
      // this.handleEditClassChange()
      let _this = this
      this.device.set.forEach(function(item, index) {
        //item 就是按循环到的对象
        //index是循环的索引，从0开始
        if (item.is_mac == 1){
          _this.device.edit_dialog.data.set_id = item.id.toString()
        }
      })
      this.getSetList()
      this.showDialog("device_edit")
    },
    showApGroupDel(item){
      this.device.del_dialog.data = {
        device_id: item.id
      }
      this.showDialog("device_del")
    },
    showApEdit(item) {
      this.ap.edit_dialog.data = {
        ap_id: item.id,
        apmac: item.mac,
        remark: item.remark,
        device_id: item.group_id
      }
      this.showDialog("ap_edit")
    },
    showApDel(item) {
      this.ap.del_dialog.data = {
        ap_id: item.id
      }
      this.showDialog("ap_del")
    },
    /**
     * 获取选择列表
     */
    getClassList(){
      this.$http.get(api.aaa.authSet).then(resp => {
        if(resp.errno !== 0)
          return
        this.device.set = resp.data
      }).finally(resp => {})
    },
    getSetList(){
      this.loadingUser = true;
      this.userParams.setID = this.device.edit_dialog.data.set_id;
      // this.userParams.classID = this.authInfo.group_id;
      // this.userParams.username = this.authuser.search.username;
      this.$http.post(api.aaa.authClass,this.userParams).then(resp => {
        if(resp.errno == 0){
          this.device.class = resp.data
          this.device.edit_dialog.data.class_id = this.device.class[0].id.toString()
          // this.userParams.total = parseInt(resp.data.total);
          // this.tableData = resp.data.list;
          this.loadingUser = false;
        }
      }).finally(resp => {})
    },
    // getAllApClassList(){
    //   this.$http.post(api.device.apGroupList,{pageSize:-1,currentPage:1}).then(resp => {
    //     if(resp.errno !== 0)
    //       return
    //     this.device.set = resp.data
    //   }).finally(resp => {})
    // },
    /**
     * Ap组
     */
    handleAddGroupChange(){
      let group_id_checked = this.device.add_dialog.data.group_id
      if(typeof group_id_checked == 'undefined' || group_id_checked == null)
      {
        this.device.add_dialog.data.shop_id = null
        this.device.add_dialog.shop_list = []
      }
      else
      {
        // 获取shoplist
        this.getShopList().then((res) => {
          this.device.add_dialog.shop_list = res.list
        })
      }
    },
    doApgroupAdd(){
      this.$http.post(api.device.addApGroup, this.device.add_dialog.data).then(resp => {
        if(resp.errno !== 0)
          return
        Notification({
          type: 'success',
          message: this.$vuetify.lang.t('$vuetify.common.success')
        });
        // 重置表单内容
        this.$refs.device_add_form.reset()
        this.reflushTable("device_list")
        this.closeDialog("device_add")
      }).finally(resp => {})
    },
    handleEditClassChange(){
      this.getSetList()
      // let group_id_checked = this.device.edit_dialog.data.group_id
      // if(typeof group_id_checked == 'undefined' || group_id_checked == null)
      // {
      //   this.device.edit_dialog.data.set_id = null
      //   this.device.edit_dialog.set = []
      // }
      // else
      // {
        // 获取shoplist
        // this.getSetList().then((res) => {
        //   this.device.edit_dialog.class = res.data
        //   console.log(this.device.edit_dialog.class)
        // })
      // }
    },
    doDeviceEdit(){
      this.$http.post(api.device.addDeviceGroup, this.device.edit_dialog.data).then(resp => {
        if(resp.errno !== 0)
          return
        Notification({
          type: 'success',
          message: this.$vuetify.lang.t('$vuetify.common.success')
        });
        this.reflushTable("device_list")
        this.reflushTable("ap_list")
        this.closeDialog("device_edit")
        this.searchTable('device_list')
      }).finally(resp => {})
    },
    getDeviceList(){
      this.$http.post(api.device.deviceList, this.device.table.filter).then(resp => {
        if(resp.errno !== 0)
          return

        this.device.table.list = resp.list
      }).finally(resp => {})
    },
    
    
    doApGroupDel(){
      this.$http.post(api.device.delApGroup, this.device.del_dialog.data).then(resp => {
        if(resp.errno !== 0)
          return
        Notification({
          type: 'success',
          message: this.$vuetify.lang.t('$vuetify.common.success')
        });
        this.reflushTable("device_list")
        this.reflushTable("ap_list")
        this.closeDialog("device_del")
      }).finally(resp => {})
    },
    handleSearchGroupChange(){
      let group_id_checked = this.device.table.filter.group_id
      if(typeof group_id_checked == 'undefined' || group_id_checked == null)
      {
        this.device.table.filter.shop_id = null
        this.device.table.shop_list = []
      }
      else
      {
        // 获取shoplist
        this.getSetList().then((res) => {
          this.device.table.shop_list = res.list
        })
      }
    },
    /**
     * Ap
     */
    doApAdd(){
      this.$http.post(api.device.addAp, this.ap.add_dialog.data).then(resp => {
        if(resp.errno !== 0)
          return
        Notification({
          type: 'success',
          message: this.$vuetify.lang.t('$vuetify.common.success')
        });
        // 重置表单内容
        this.$refs.ap_add_form.reset()
        this.reflushTable("ap_list")
        this.closeDialog("ap_add")
      }).finally(resp => {})
    },
    doApEdit(){
      this.$http.post(api.device.editAp, this.ap.edit_dialog.data).then(resp => {
        if(resp.errno !== 0)
          return
        Notification({
          type: 'success',
          message: this.$vuetify.lang.t('$vuetify.common.success')
        });
        this.reflushTable("ap_list")
        this.closeDialog("ap_edit")
      }).finally(resp => {})
    },
    doApDel(){
      this.$http.post(api.device.delAp, this.ap.del_dialog.data).then(resp => {
        if(resp.errno !== 0)
          return
        Notification({
          type: 'success',
          message: this.$vuetify.lang.t('$vuetify.common.success')
        });
        this.reflushTable("ap_list")
        this.closeDialog("ap_del")
      }).finally(resp => {})
    },
    // 查看ap详情
    showLook(data){
      this.$router.push({
        'path': '/device/ap_info',
        'query':{
          id:data.id
        }
      })
    },
    /* 下载导入模板 */
    downloadApimportTemplate(){
      axios({
        method: 'GET',
        url: api.device.getApimportTemplateUrl,
        responseType: 'blob'
      }).then(response => {
        if(response.status != 200 || !response.data)
        {
          Notification({
            type: 'warning',
            message: "导出失败"
          });
          return
        }
        let url = window.URL.createObjectURL(new Blob([response.data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', 'Ap列表模板.xlsx')

        document.body.appendChild(link)
        link.click()
      }).catch((error) => {
        Notification({
          type: 'warning',
          message: "导出失败"
        });
        return
      }).finally(resp => {
        this.authdetail_list.export_button.loading = false
      })
    },
    /* 导入Ap */
    doApImport(){
      var formData = new FormData()
      formData.append('apimport_template', this.ap.import_dialog.data.file)
      this.$http.post(api.device.importAp, formData, {
        headers: {'Content-Type': 'multipart/form-data'},
      }).then(resp => {
        if(resp.errno != '0')
          return false;
        Notification({
          type: 'success',
          message: this.$vuetify.lang.t('$vuetify.common.success')
        });
        this.$refs.ap_import_form.reset()
        this.reflushTable("ap_list")
        this.closeDialog("ap_import")
      }).finally(resp => {})
    }
  }
}
</script>
